import { render, staticRenderFns } from "./specification.vue?vue&type=template&id=18d32370&lang=pug&"
import script from "./specification.vue?vue&type=script&setup=true&lang=js&"
export * from "./specification.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./specification.vue?vue&type=style&index=0&id=18d32370&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports